import './AnchorList.css';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, canUseDOM, hideContainerByChild, getDictionaryItem, getColorByTheme, getPageThemeColors } from '../../utils';
import { ReactComponent as ArrowIcon } from '../../resources/icons/IconChevronBottomRight.svg';
import SelectReplace from '../atoms/SelectReplace';
const compareLinksArrays = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  let compareAccum = 0;
  arr1.forEach(link => {
    if (arr2.find(item => item.id === link.id)) {
      compareAccum++;
    }
  });
  return compareAccum === arr1.length;
};
const AnchorList = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const dictionary = get(fields, 'data.dictionary');
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [links, setLinks] = useState([]);
  const linksRef = useRef([]);
  const [isVdsite, setIsVdsite] = useState(true);
  const [selectValue, setSelectValue] = useState();
  const mobileDefaultOption = getDictionaryItem(dictionary, 'mobileDefaultOption');
  const title = get(fields, 'data.datasource.title.jss.value');
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const ColorHex = get(params, 'ColorHex');
  const variables = BackgroundColorHex ? {
    "--m03-anchor-nav-primary-color": BackgroundColorHex,
    "--m03-anchor-nav-active-primary-color": ActiveColorHex,
    "--m03-anchor-nav-color": ColorHex
  } : {
    "--m03-anchor-nav-primary-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--m03-anchor-nav-active-primary-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m03-anchor-nav-color": getColorByTheme(primaryPageThemeColor)
  };
  const selectPrimaryColor = BackgroundColorHex || (primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary);
  const options = useMemo(() => {
    return links.map((link, index) => ({
      value: link.id,
      label: link.dataset.title,
      index: index,
      link: link
    }));
  }, [links]);
  useEffect(() => {
    const checkLinks = () => {
      const domLinks = [].slice.call(document.querySelectorAll('[data-id="anchor-item"]'));
      if (!compareLinksArrays(domLinks, linksRef.current)) {
        linksRef.current = domLinks;
        setLinks(domLinks);
      }

      // @ts-ignore
      hideParentContainer(domLinks);
    };
    const interval = setInterval(checkLinks, 1000);
    setTimeout(checkLinks, 100);
    setTimeout(checkLinks, 500);
    return () => {
      clearInterval(interval);
    };
  }, []);
  const changeEvent = value => {
    setSelectValue(value);
    scrollToItem(value.link, value.index);
  };
  const scrollToItem = (link, index) => {
    const scroll = (links, callback) => {
      if (canUseDOM && links.length) {
        var header = document.querySelector('.main-navigation-block');
        if (header) {
          header = header.closest('.module-group');
        }
        if (header) {
          header = header.parentNode;
        }
        document.documentElement.scrollTop = links[0].nextSibling.offsetTop - (header ? header.offsetHeight : 0);
        if (links.length > 1) {
          setTimeout(() => scroll(links.slice(1), callback), 100);
        } else {
          callback();
        }
      }
    };
    if (canUseDOM) {
      link.click();
      setTimeout(() => {
        var scrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        scroll(links.slice(0, index + 1), () => {
          document.documentElement.style.scrollBehavior = scrollBehavior;
        });
      }, 100);
    }
  };
  const hideParentContainer = domLinks => {
    let arr = [...domLinks];
    if (domLinks.length > 0) {
      //if all the links don't have title, parent container will be hidden
      arr = arr.map(item => item.dataset.title ? true : false).filter(item => item !== false);
      if (arr.length === 0) {
        hideContainerByChild('.anchor-list', '.container');
      }
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "anchor-list",
    style: variables
  }, /*#__PURE__*/React.createElement("h3", {
    className: "anchor-list__title"
  }, title), links.map((link, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "anchor-list__item d-none d-md-block",
      key: link.id
    }, /*#__PURE__*/React.createElement("span", {
      onClick: () => scrollToItem(link, index),
      tabIndex: 0,
      onKeyPress: event => {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      }
    }, /*#__PURE__*/React.createElement(ArrowIcon, {
      className: "icon"
    }), link.dataset.title));
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none"
  }, /*#__PURE__*/React.createElement(SelectReplace, {
    name: "jump-to-section-selector",
    id: "jump-to-section-selector",
    label: title,
    options: options,
    placeholder: mobileDefaultOption,
    changeEvent: changeEvent,
    componentColor: selectPrimaryColor,
    value: selectValue
  }))));
};
const commonStyles = "c1v8hkws";
const ltrStyles = "lhg1wvg";
const rtlStyles = "r1tv99qc";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default AnchorList;